import { Listbox as FASTListbox } from '@microsoft/fast-components';
import { foundationListboxStyles as styles } from './listbox.styles';
import { foundationListboxTemplate as template } from './listbox.template';
/**
 * @tagname %%prefix%%-listbox
 */
export class Listbox extends FASTListbox {
}
// explicitly declaring for extensibility
export const foundationListboxShadowOptions = undefined;
export const defaultListboxConfig = {};
export const foundationListbox = Listbox.compose(Object.assign({ baseName: 'listbox', template,
    styles, shadowOptions: foundationListboxShadowOptions }, defaultListboxConfig));
